'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _baseReportController = require('../../baseReportController');

var _baseReportController2 = _interopRequireDefault(_baseReportController);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SystemUsageController = function (_BaseReportController) {
  (0, _inherits3.default)(SystemUsageController, _BaseReportController);

  function SystemUsageController(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, SystemUsageController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SystemUsageController.__proto__ || (0, _getPrototypeOf2.default)(SystemUsageController)).call(this, reportingService, loadingService, utilsService));

    if (!authService.validateUser(true, 'Reports', enums.PERMISSION_TYPE.View, true)) {
      return (0, _possibleConstructorReturn3.default)(_this);
    }

    _this.authService = authService;
    _this.reportingService = reportingService;
    _this.userService = userService;
    _this.enums = enums;
    _this.loadingService = loadingService;
    _this.lookupService = lookupService;
    _this.$q = $q;
    _this.$scope = $scope;
    _this.printService = printService;
    _this.exportService = exportService;
    _this.utilsService = utilsService;

    _this.reportCriteria = {};
    _this.dtPopups = {};
    _this.errMsgs = [];

    _this.panels = {
      reportCriteria: true,
      reportSummary: false,
      reportData: false
    };

    _this.summary = [];
    _this.locationDetailsHidden = [];

    _this.getDateRangeList();
    _this.reset();
    return _this;
  }

  (0, _createClass3.default)(SystemUsageController, [{
    key: 'convertEnumToKeyValueList',
    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
      var objList = [];

      if (defaultOption) {
        objList.push({
          id: null,
          name: 'Please Select'
        });
      }

      for (var prop in enumObj) {
        objList.push({
          id: enumObj[prop],
          name: prop
        });
      }

      return objList;
    }
  }, {
    key: 'getDateRangeList',
    value: function getDateRangeList() {
      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
    }
  }, {
    key: 'showDatePopup',
    value: function showDatePopup(fieldName) {
      this.dtPopups[fieldName] = true;
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.$scope.$broadcast('reports:reset');

      this.summary = [];

      this.errMsgs = [];

      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
      this.reportCriteria.startDate = new Date();
      this.reportCriteria.endDate = new Date();
      this.reportCriteria.additionalParameter1 = "0";
    }
  }, {
    key: 'runReport',
    value: function runReport() {
      var _this2 = this;

      this.panels.reportData = true;

      if (!this.validateCriteria()) {
        return;
      }

      this.loadingService.showLoading('reportData', 'Running Report ...');

      this.reportingService.runReport('systemUsage', this.parseCriteria()).then(function (response) {
        _this2.reportData = response.data.usages;
        _this2.reportSummary = response.data.summary;

        (0, _lodash.map)(_this2.reportData, function (usage) {
          _this2.locationDetailsHidden[usage.locationName] = false;
        });
      }).finally(function () {
        _this2.loadingService.hideLoading('reportData');
      });
    }
  }, {
    key: 'validateCriteria',
    value: function validateCriteria() {
      this.errMsgs = [];

      if (!this.reportCriteria.startDate) {
        this.errMsgs.push('Please provide a Start Date');
      }

      if (!this.reportCriteria.endDate) {
        this.errMsgs.push('Please provide an End Date');
      }

      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
        this.errMsgs.push('Start Date can not be greater than End Date');
      }

      return this.errMsgs.length === 0;
    }
  }, {
    key: 'parseCriteria',
    value: function parseCriteria() {
      var parsedCriteria = {};

      this.parseStartAndEndDate(parsedCriteria);

      parsedCriteria.dateRange = this.reportCriteria.dateRangeOption.id;
      parsedCriteria.startDate = this.reportCriteria.startDate.toISOString();
      parsedCriteria.endDate = this.reportCriteria.endDate.toISOString();
      parsedCriteria.additionalParameter1 = this.reportCriteria.additionalParameter1;

      return parsedCriteria;
    }
  }, {
    key: 'onReportRun',
    value: function onReportRun(summary) {
      this.summary = summary;
    }
  }, {
    key: 'printReport',
    value: function printReport() {
      if (!this.validateCriteria()) {
        return;
      }

      this.printService.printReport('All Enquiries', this.parseCriteria());
    }
  }, {
    key: 'exportReport',
    value: function exportReport() {
      if (!this.validateCriteria()) {
        return;
      }

      this.exportService.exportReport('System Usage', this.parseCriteria());
    }
  }, {
    key: 'sumDetails',
    value: function sumDetails(details, detailType) {
      if (detailType === 'created') {
        return (0, _lodash.sumBy)(details, function (d) {
          return d.enquiriesCreated;
        });
      } else if (detailType === 'lost') {
        return (0, _lodash.sumBy)(details, function (d) {
          return d.enquiriesLost;
        });
      } else if (detailType === 'confirmed') {
        return (0, _lodash.sumBy)(details, function (d) {
          return d.enquiriesConfirmed;
        });
      } else if (detailType === 'closed') {
        return (0, _lodash.sumBy)(details, function (d) {
          return d.enquiriesClosed;
        });
      }
    }
  }]);
  return SystemUsageController;
}(_baseReportController2.default);

exports.default = SystemUsageController;


// WEBPACK FOOTER //
// ./client/app/components/reports/adminReports/systemUsage/systemUsage.controller.js